export default __webpack_public_path__ + "static/media/1-tracejado.38004ad8.svg";